export var rowsPerPageOptions = [5, 10, 15];
export var DATA_CELL_TYPE = {
  LINK: 'LINK',
  DATE: 'DATE',
  TRUNCATED: 'TRUNCATED'
};